module.exports = __webpack_public_path__ + "img/logo-altice-empresas-h-b.423b9bb1.png";